const THOUSAND = 1_000;
const MILLION = 1_000_000;
const DECIMAL_PRECISION = 10;

export function formatCompact(n: number): string {
	if (n >= MILLION) {
		const m = Math.round((n / MILLION) * DECIMAL_PRECISION) / DECIMAL_PRECISION;
		return (m % 1 === 0 ? String(m) : m.toFixed(1)) + 'M';
	}
	if (n >= THOUSAND) {
		const k = Math.round((n / THOUSAND) * DECIMAL_PRECISION) / DECIMAL_PRECISION;
		return (k % 1 === 0 ? String(k) : k.toFixed(1)) + 'K';
	}
	return String(Math.round(n));
}
